/**
 * @generated SignedSource<<79cda9a8a207ac397a141bd7897c3537>>
 * @relayHash 3037c8cb08fdd5bd0f2bb8885e4a147b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SandboxJiraPageQuery$variables = {
  cloudId: string;
  enableDefer: boolean;
};
export type SandboxJiraPageQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"SandboxJiraAiStuff" | "SandboxJiraCriticalData" | "SandboxJiraIssueSearch" | "SandboxJiraUserPreferences">;
  };
};
export type SandboxJiraPageQuery = {
  response: SandboxJiraPageQuery$data;
  variables: SandboxJiraPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enableDefer"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SandboxJiraPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "SandboxJiraCriticalData"
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SandboxJiraUserPreferences"
                }
              ]
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SandboxJiraAiStuff"
                }
              ]
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": [
                    (v1/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "enableDefer",
                      "variableName": "enableDefer"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "SandboxJiraIssueSearch"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SandboxJiraPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "ScalarField",
            "name": "childIssuesLimit"
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxJiraPageQuery$defer$SandboxJiraUserPreferences_PVNZy",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isIssueViewCrossFlowBannerDismissed"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isCustomNavBarThemeFlagDismissed"
                  }
                ]
              }
            ]
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxJiraPageQuery$defer$SandboxJiraAiStuff_PVNZy",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "atlassianIntelligenceProductFeatureInput",
                    "value": {
                      "product": "JIRA_SOFTWARE"
                    }
                  },
                  (v1/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "shouldShowAtlassianIntelligence"
              },
              {
                "args": (v2/*: any*/),
                "kind": "ScalarField",
                "name": "isRovoEnabled"
              }
            ]
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxJiraPageQuery$defer$SandboxJiraIssueSearch_1jcU60",
            "selections": [
              {
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "issueSearchInput",
                    "value": {
                      "jql": "ORDER BY created DESC"
                    }
                  }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      },
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              (v3/*: any*/)
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "idsOrAliases",
                                "value": [
                                  "assignee",
                                  "reporter",
                                  "status"
                                ]
                              }
                            ],
                            "kind": "LinkedField",
                            "name": "fieldsByIdOrAlias",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              (v5/*: any*/),
                              {
                                "if": "enableDefer",
                                "kind": "Defer",
                                "label": "SandboxJiraIssueWithDeferCard$defer$SandboxJiraIssueFieldEditability",
                                "selections": [
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueField"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isEditableInIssueView"
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v3/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraSingleSelectUserPickerField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraStatusField"
                              }
                            ],
                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"assignee\",\"reporter\",\"status\"])"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4",
    "metadata": {},
    "name": "SandboxJiraPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1a8ba1e200e80a9f80ac57367382ae4b";

export default node;
